// Event date in Europe/Amsterdam timezone
export const EVENT_DATE = "2026-07-18"; // Pal Mundo Festival 2026

export function hhmmToMinutes(hhmm: string | null | undefined): number | null {
  if (!hhmm) return null;
  if (hhmm === "NTB") return null;
  const m = /^(\d{1,2}):(\d{2})$/.exec(hhmm);
  if (!m) return null;
  const h = Number(m[1]);
  const min = Number(m[2]);
  // Times after midnight (00:00 - 06:00) belong to the next day in show context
  if (h < 6) return h * 60 + min + 24 * 60;
  return h * 60 + min;
}

// Real elapsed minutes since show-day start (EVENT_DATE 00:00 Europe/Amsterdam).
// Negative pre-event, positive during/after. NEVER use sentinels (-1, 99999):
// every consumer does pure arithmetic and a sentinel breaks formatRel,
// isCurrent, isPast and "next" lookups, leaving the UI showing static
// pre-event garbage like "Volgend ECC: over 10u 31m" until midnight.
export function minutesNow(d: Date = new Date()): number {
  const dayStart = new Date(EVENT_DATE + "T00:00:00+02:00").getTime();
  return Math.floor((d.getTime() - dayStart) / 60000);
}

export function formatRel(targetMin: number, nowMin: number): string {
  const delta = targetMin - nowMin;
  if (delta < 0) {
    const a = -delta;
    if (a < 60) return `${a} min terug`;
    return `${Math.floor(a / 60)}u ${a % 60}m terug`;
  }
  if (delta === 0) return "nu";
  if (delta < 60) return `over ${delta} min`;
  return `over ${Math.floor(delta / 60)}u ${delta % 60}m`;
}

export function formatHHMM(d: Date = new Date()): string {
  return d.toLocaleTimeString("nl-NL", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZone: "Europe/Amsterdam",
  });
}

export function isCurrent(
  vanMin: number | null,
  totMin: number | null,
  nowMin: number,
): boolean {
  if (vanMin == null) return false;
  const end = totMin ?? vanMin + 60;
  return nowMin >= vanMin && nowMin < end;
}
